import React from "react";
import {
  FaCalendarAlt,
  FaFileInvoiceDollar,
  FaInfoCircle,
  FaTag,
  FaCircle,
} from "react-icons/fa";

function BillingCard({ billing }) {
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "paid":
        return "bg-[#8FCD00] bg-opacity-10 text-[#8FCD00]";
      case "pending":
        return "bg-amber-50 text-amber-600";
      case "overdue":
        return "bg-red-50 text-red-500";
      default:
        return "bg-gray-50 text-gray-600";
    }
  };

  return (
    <div className="bg-white rounded-lg p-5 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100">
      <div className="flex justify-between items-start mb-3">
        <div className="flex items-center space-x-2">
          <div className="bg-[#363062] bg-opacity-10 p-2 rounded-lg">
            <FaFileInvoiceDollar className="text-[#363062] text-sm" />
          </div>
          <div className="text-sm font-medium text-[#363062]">
            {billing.identifier}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <FaCircle
            className={`text-xs ${
              billing.status.toLowerCase() === "paid"
                ? "text-[#8FCD00]"
                : billing.status.toLowerCase() === "pending"
                ? "text-amber-500"
                : billing.status.toLowerCase() === "overdue"
                ? "text-red-500"
                : "text-gray-500"
            }`}
          />
          <span className="text-xs font-medium text-gray-600">
            {billing.status}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-3">
        <div className="flex items-center space-x-2">
          <div className="bg-gray-50 p-1.5 rounded">
            <FaCalendarAlt className="text-gray-400 text-xs" />
          </div>
          <div>
            <div className="text-[11px] text-gray-400">Due Date</div>
            <div className="text-xs font-medium text-gray-600">
              {billing.dueDate}
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="bg-gray-50 p-1.5 rounded">
            <FaTag className="text-gray-400 text-xs" />
          </div>
          <div>
            <div className="text-[11px] text-gray-400">Type</div>
            <div className="text-xs font-medium text-gray-600 capitalize">
              {billing.billingType}
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-start space-x-2 mb-3 bg-gray-50 p-2 rounded">
        <FaInfoCircle className="text-gray-400 text-xs mt-0.5" />
        <div className="text-xs text-gray-500 capitalize">
          {billing.description}
        </div>
      </div>

      <div className="flex justify-between items-center pt-3 border-t border-gray-100">
        <div className="text-xs text-gray-400">Amount Due</div>
        <div className="text-sm font-semibold text-[#363062]">
          ₱{billing.amount}
        </div>
      </div>
    </div>
  );
}

export default BillingCard;